import React, { useEffect } from 'react';
import '../../styles/ServicePage.css';

const AgbPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="service-page">
      {/* Header Section */}
      <header className="service-header">
        <div className="container">
          <div className="service-header-content">
            <h1>Allgemeine Geschäftsbedingungen</h1>
            <p>
              AGB zur Erbringung von ingenieurtechnischen Leistungen
            </p>
          </div>
        </div>
      </header>

      <div className="service-content">
        <div className="container">
          <section className="service-section">
            <p style={{ marginBottom: '1.5rem', fontStyle: 'italic' }}>
              Stand: Mai 2026
            </p>
            <div className="service-intro" style={{ marginBottom: '2rem' }}>
              <p>
                Die nachfolgenden Allgemeinen Geschäftsbedingungen regeln die Geschäftsbeziehung
                zwischen dem Auftraggeber und der IB Neubaur GmbH (nachfolgend „Ingenieurbüro").
                Sie gelten gegenüber Unternehmern im Sinne des § 14 BGB. Verbraucher
                (§ 13 BGB) haben darüber hinausgehende gesetzliche Rechte, die durch diese
                AGB nicht eingeschränkt werden.
              </p>
              <p style={{ marginTop: '1rem' }}>
                <a 
                  href="/assets/agbs/Allgemeine Geschäftsbedingungen zur Erbringung von ingenieurtechnischen Leistungen.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                  style={{ display: 'inline-block', textDecoration: 'none' }}
                >
                  AGBs als PDF herunterladen
                </a>
              </p>
            </div>

            {/* 1. Geltungsbereich */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">1. Geltungsbereich und Abweichungen</h2>
              <div style={{ paddingLeft: '1.5rem' }}>
                <p><strong>1.1</strong> Die nachstehenden Allgemeinen Geschäftsbedingungen (AGB) gelten für alle gegenwärtigen und zukünftigen Verträge zwischen dem Auftraggeber und dem Ingenieurbüro.</p>
                <p><strong>1.2</strong> Abweichende oder ergänzende Bedingungen des Auftraggebers gelten nur, wenn sie vom Ingenieurbüro ausdrücklich und schriftlich anerkannt und bestätigt werden.</p>
              </div>
            </div>

            {/* 2. Angebote */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">2. Angebote und Nebenabreden</h2>
              <div style={{ paddingLeft: '1.5rem' }}>
                <p><strong>2.1</strong> Angebote des Ingenieurbüros sind, sofern nicht anders angegeben, freibleibend. Dies betrifft sämtliche Angaben, einschließlich des Honorars. Ändert sich zwischen Angebotserstellung und Rechnungslegung die maßgebliche Honorarordnung, ist das Ingenieurbüro berechtigt, das Honorar entsprechend anzupassen.</p>
                <p><strong>2.2</strong> Enthält die Auftragsbestätigung des Ingenieurbüros Abweichungen vom ursprünglichen Auftrag, gelten diese als genehmigt, sofern der Auftraggeber nicht unverzüglich schriftlich widerspricht.</p>
                <p><strong>2.3</strong> Nebenabreden und Vereinbarungen bedürfen der Schriftform.</p>
              </div>
            </div>

            {/* 3. Auftragserteilung */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">3. Auftragserteilung</h2>
              <div style={{ paddingLeft: '1.5rem' }}>
                <p><strong>3.1</strong> Art und Umfang der Leistungen ergeben sich aus dem Vertrag, eventuellen Vollmachten sowie diesen AGB.</p>
                <p><strong>3.2</strong> Änderungen oder Ergänzungen des Auftrags werden erst mit schriftlicher Bestätigung des Ingenieurbüros Bestandteil des Vertragsverhältnisses.</p>
                <p><strong>3.3</strong> Das Ingenieurbüro verpflichtet sich zur ordnungsgemäßen und fachgerechten Durchführung der Leistungen nach den allgemein anerkannten Regeln der Technik und den Grundsätzen der Wirtschaftlichkeit.</p>
                <p><strong>3.4</strong> Das Ingenieurbüro ist berechtigt, im Namen und auf Rechnung des Auftraggebers andere befugte Dritte heranzuziehen. Der Auftraggeber ist darüber schriftlich zu informieren und kann binnen 10 Tagen widersprechen.</p>
                <p><strong>3.5</strong> Das Ingenieurbüro kann zur Vertragserfüllung auch Subplaner im eigenen Namen und auf eigene Rechnung beauftragen. Der Auftraggeber ist hierüber schriftlich zu verständigen und kann binnen einer Woche widersprechen.</p>
              </div>
            </div>

            {/* 4. Gewährleistung */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">4. Gewährleistung und Schadenersatz</h2>
              <div style={{ paddingLeft: '1.5rem' }}>
                <p><strong>4.1</strong> Gewährleistungsansprüche setzen eine schriftliche Mängelrüge per eingeschriebenem Brief binnen 14 Tagen nach Übergabe der Leistung oder Teilleistung voraus.</p>
                <p><strong>4.2</strong> Ansprüche auf Wandelung oder Preisminderung sind ausgeschlossen. Das Ingenieurbüro ist verpflichtet, innerhalb angemessener Frist Verbesserungen oder fehlende Leistungen nachzuholen.</p>
                <p><strong>4.3</strong> Das Ingenieurbüro erbringt seine Leistungen mit der für einen Fachmann üblichen Sorgfalt.</p>
              </div>
            </div>

            {/* 5. Rücktritt */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">5. Rücktritt vom Vertrag</h2>
              <div style={{ paddingLeft: '1.5rem' }}>
                <p><strong>5.1</strong> Ein Rücktritt vom Vertrag ist nur aus wichtigem Grund möglich.</p>
                <p><strong>5.2</strong> Bei Leistungsverzug des Ingenieurbüros ist ein Rücktritt des Auftraggebers erst nach Setzen einer angemessenen Nachfrist per eingeschriebenem Brief zulässig.</p>
                <p><strong>5.3</strong> Bei Verzug des Auftraggebers mit Mitwirkungspflichten ist das Ingenieurbüro zum Rücktritt berechtigt.</p>
                <p><strong>5.4</strong> Bei berechtigtem Rücktritt des Ingenieurbüros behält dieses den Anspruch auf das gesamte vereinbarte Honorar.</p>
              </div>
            </div>

            {/* 6. Honorar */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">6. Honorar</h2>
              <div style={{ paddingLeft: '1.5rem' }}>
                <p><strong>6.1</strong> Grundlage der Honoraransprüche sind die jeweils gültigen Honorarordnungen für Architekten und Ingenieure (HOAI) sowie die entsprechenden Leistungsbilder.</p>
                <p><strong>6.2</strong> Honorare werden in Euro berechnet.</p>
                <p><strong>6.3</strong> Die gesetzliche Umsatzsteuer wird zusätzlich in der bei Vertragsabschluss geltenden Höhe berechnet.</p>
              </div>
            </div>

            {/* 7. Haftung */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">7. Haftung</h2>
              <div style={{ paddingLeft: '1.5rem' }}>
                <p><strong>7.1</strong> Für Vorsatz und grobe Fahrlässigkeit haftet das Ingenieurbüro unbeschränkt.</p>
                <p><strong>7.2</strong> Bei einfacher Fahrlässigkeit ist die Haftung dem Grunde und der Höhe nach auf den Umfang begrenzt, der durch eine angemessene Berufshaftpflichtversicherung gedeckt ist.</p>
                <p><strong>7.3</strong> Im Haftungsfall kann das Ingenieurbüro verlangen, zunächst eine Nachbesserung durchführen zu dürfen.</p>
              </div>
            </div>

            {/* 8. Geheimhaltung */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">8. Geheimhaltung</h2>
              <div style={{ paddingLeft: '1.5rem' }}>
                <p><strong>8.1</strong> Das Ingenieurbüro ist verpflichtet, alle Informationen des Auftraggebers vertraulich zu behandeln.</p>
                <p><strong>8.2</strong> Nach Abschluss des Auftrags ist das Ingenieurbüro berechtigt, das Projektergebnis zu Referenzzwecken zu veröffentlichen, sofern keine abweichenden Vereinbarungen bestehen.</p>
              </div>
            </div>

            {/* 9. Urheberrechte */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">9. Urheberrechte</h2>
              <div style={{ paddingLeft: '1.5rem' }}>
                <p><strong>9.1</strong> Sämtliche vom Ingenieurbüro erstellten Unterlagen (Pläne, Berichte, technische Dokumente) sind urheberrechtlich geschützt.</p>
                <p><strong>9.2</strong> Eine Veröffentlichung, Weitergabe oder wiederholte Nutzung durch den Auftraggeber oder Dritte bedarf der vorherigen Zustimmung des Ingenieurbüros.</p>
                <p><strong>9.3</strong> Bei Veröffentlichungen ist der Name des Ingenieurbüros anzugeben.</p>
              </div>
            </div>

            {/* 10. Verjährung */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">10. Verjährung</h2>
              <div style={{ paddingLeft: '1.5rem' }}>
                <p><strong>10.1</strong> Für die Verjährung gelten die gesetzlichen Bestimmungen (§ 636 BGB), sofern im Vertrag nichts Abweichendes vereinbart wurde.</p>
                <p><strong>10.2</strong> Der Beginn der Verjährung richtet sich nach Art und Umfang der übertragenen Leistungen.</p>
                <p><strong>10.3</strong> Die Verjährung von Honoraransprüchen beginnt mit Ablauf des Jahres, in dem die Rechnung zugestellt wurde.</p>
              </div>
            </div>

            {/* 11. Erfüllungsort */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">11. Erfüllungsort und Gerichtsstand</h2>
              <div style={{ paddingLeft: '1.5rem' }}>
                <p><strong>11.1</strong> Erfüllungsort ist die Niederlassung des Ingenieurbüros.</p>
              </div>
            </div>

            {/* 12. Schlussbestimmungen */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">12. Schlussbestimmungen</h2>
              <div style={{ paddingLeft: '1.5rem' }}>
                <p><strong>12.1</strong> Änderungen, Ergänzungen und Nebenabreden bedürfen der Schriftform.</p>
                <p><strong>12.2</strong> Bei Inkrafttreten neuer Honorarordnungen gelten deren Bestimmungen sinngemäß.</p>
                <p><strong>12.3</strong> Sollten einzelne Bestimmungen dieses Vertrages unwirksam sein, bleibt die Wirksamkeit der übrigen Regelungen unberührt.</p>
              </div>
            </div>

            {/* Download Button */}
            <div style={{ textAlign: 'center', marginTop: '3rem', padding: '2rem', background: 'rgba(183, 28, 28, 0.05)', borderRadius: '12px' }}>
              <h3 style={{ marginBottom: '1rem' }}>Vollständige AGBs herunterladen</h3>
              <p style={{ marginBottom: '1.5rem' }}>
                Laden Sie die vollständige Version unserer Allgemeinen Geschäftsbedingungen als PDF herunter.
              </p>
              <a 
                href="/assets/agbs/Allgemeine Geschäftsbedingungen zur Erbringung von ingenieurtechnischen Leistungen.pdf" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-primary"
                style={{ textDecoration: 'none' }}
              >
                AGBs als PDF öffnen
              </a>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AgbPage;



